import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Colors } from "../../config/Constants";
import Button from "../Button";

interface Props {
  label: string;
  outletId: any;
  product: any;
  onSoldoutClick: any;
  hideButtons?: boolean;
}

const CreateHeader = ({
  label,
  outletId,
  product,
  onSoldoutClick,
  hideButtons = false,
}: Props) => {
  const navigate = useNavigate();

  const navigateTo = () => {
    navigate(`/admin/create-product?outletId=${outletId}&product=${product}`);
  };

  return (
    <StyledCreateHeader>
      <StyledPageHeader>{label}</StyledPageHeader>
      {!hideButtons && (
        <CreateHeaderActions>
          {product !== "aqua_zone" && (
            <Button
              disabled={!outletId || !product}
              width="180px"
              variant="filled"
              label="Special Day Pricing"
              color={Colors.red}
              onClick={() =>
                navigate(
                  `/admin/special-day-pricing?outletId=${outletId}&product=${product}`
                )
              }
            />
          )}
          {product !== "aqua_zone" && (
            <Button
              disabled={!outletId || !product}
              width="180px"
              variant="filled"
              label="Sold Out"
              color={Colors.red}
              onClick={() => onSoldoutClick()}
            />
          )}
          <Button
            disabled={!outletId || !product}
            width="180px"
            variant="filled"
            label={"Create Product"}
            color={Colors.red}
            onClick={() => navigateTo()}
          />
        </CreateHeaderActions>
      )}
    </StyledCreateHeader>
  );
};

const StyledPageHeader = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  line-height: 1.75rem;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const StyledCreateHeader = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  padding-bottom: 1rem;
  align-items: center;
  @media only screen and (max-width: 768px) {
    padding-bottom: 0.5rem;
  }
`;

const CreateHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  @media only screen and (max-width: 768px) {
    // flex-direction: column;
    justify-content: center;
    gap: 0.5rem;
    flex: 1;
    // padding: 1.5rem;
  }
`;
export default CreateHeader;
